import React, { useMemo } from 'react';
import { Flex, Text, Button } from '@spothero/ui';
import dayjs from 'utils/dayjs-timezone';
const NewTimesDisplay = ({ rateDiff, handleBackToTimeSelect, timezone, }) => {
    const timeDisplay = useMemo(() => {
        const starts = dayjs(rateDiff.starts).tz(timezone);
        const ends = dayjs(rateDiff.ends).tz(timezone);
        const startsString = starts.format('MMMM D, h:mm A');
        let endsString = ends.format('MMMM D, h:mm A');
        if (starts.isSame(ends, 'date')) {
            endsString = ends.format('h:mm A');
        }
        return `${startsString} - ${endsString}`;
    }, [rateDiff.starts, rateDiff.ends, timezone]);
    return (<Flex flexDirection="column">
            <Text fontWeight="semibold" fontSize="sm" color="text.secondary.light">
                New Times
            </Text>
            <Flex gap={2}>
                <Text>{timeDisplay}</Text>
                <Button data-testid="NewTimesDisplay-change-button" variant="tertiary" onClick={() => handleBackToTimeSelect()}>
                    Change
                </Button>
            </Flex>
        </Flex>);
};
export default NewTimesDisplay;
